<template>
  <div/>
</template>
<script>
import { mapState } from 'vuex'
import { EMPRESA_TIPOS } from '../../utils/types'
export default {
  computed: {
    ...mapState('app', ['strings', 'user', 'idioma'])
  },
  async created () {
    if (this.user.NOME === '' || this.user.NOME === null || this.user.endereco === null || !this.user.endereco.cidade || (this.user.endereco.cidade && this.user.endereco.cidade === '')) return
    let res = await this.verificaPendencias()
    if (res.data.data.length > 0) {
      sessionStorage.setItem('dependeAprovacao', true)
      let aceitaVinculo = await this.$confirm(this.$store.state, this.strings[this.idioma].aceito_vinculo.format(res.data.data[0].empresa.nome + ' - ' + this.strings[this.idioma][EMPRESA_TIPOS[res.data.data[0].acesso]]))
      let respostaVinculo = await this.axios.post(aceitaVinculo === 'nao' ? 'auth/reprovarVinculo' : 'auth/aprovarVinculo', {})
      if (respostaVinculo) {
        sessionStorage.setItem('dependeAprovacao', false)
        window.location.href = '/dashboard'
      }
    } else {
      // função buid-in localizada em utils.js
      this.verificaDadosFaltantes(this.user)
    }
    this.verificaPendenciasEmpTecnico()
  },
  methods: {
    async verificaPendenciasEmpTecnico () {
      let res = await this.axios.post('empresa/verificaPendenciaEmpTecnico')
      if (res.data.data && res.data.data !== null) {
        sessionStorage.setItem('dependeAprovacao', true)
        let aceitaVinculo = await this.$confirm(this.$store.state, this.strings[this.idioma].aceito_add_contato.format(res.data.data.nomeEmpresa))
        let dado = {
          id: res.data.data.id,
          id_empresa: res.data.data.id_empresa,
          aceito: aceitaVinculo === 'nao' ? 0 : 1,
          status: aceitaVinculo === 'nao' ? 0 : 1
        }
        let respostaVinculo = await this.axios.post('empresa/aceiteEmpTecnico', { ...dado })
        if (respostaVinculo) {
          sessionStorage.setItem('dependeAprovacao', false)
          window.location.href = '/dashboard'
        }
      }
      return res
    },
    async verificaPendencias () {
      let res = await this.axios.post('auth/getPendenciasVinculo', {})
      if (
        (this.user.emp_user) &&
                (
                  (this.user.emp_user !== null && this.user.emp_user.supervisor && this.user.emp_user.supervisor !== null && parseInt(this.user.emp_user.supervisor.autorizado) === 0) ||
                  (this.user.emp_user !== null && parseInt(this.user.emp_user.lido) === 0)
                )
      ) {
        this.$store.commit('setEmpresa', null)
        localStorage.setItem('empresa', JSON.stringify(null))
        res.data.data.empresa = null
      }
      return res
    }
  }
}
</script>
